import { axios } from 'configs'
import type {
  TAdminAccount,
  TCreateAdminAccountRequest,
  TUpdateAdminAccountMembershipRequest,
  TUpdateAdminAccountProfileRequest,
  TUpdateAdminAccountSecurityRequest,
} from 'types'

export const listAdminAccounts = async (): Promise<TAdminAccount[]> => {
  const response = await axios.get<TAdminAccount[]>('/admin/accounts')
  return response.data
}

export const getAdminAccount = async (
  accountId: number,
): Promise<TAdminAccount> => {
  const response = await axios.get<TAdminAccount>(`/admin/accounts/${accountId}`)
  return response.data
}

export const createAdminAccount = async (
  request: TCreateAdminAccountRequest,
): Promise<TAdminAccount> => {
  const response = await axios.post<TAdminAccount>('/admin/accounts', request)
  return response.data
}

export const updateAdminAccountProfile = async (
  accountId: number,
  request: TUpdateAdminAccountProfileRequest,
): Promise<TAdminAccount> => {
  const response = await axios.patch<TAdminAccount>(
    `/admin/accounts/${accountId}/profile`,
    request,
  )
  return response.data
}

export const updateAdminAccountSecurity = async (
  accountId: number,
  request: TUpdateAdminAccountSecurityRequest,
): Promise<TAdminAccount> => {
  const response = await axios.patch<TAdminAccount>(
    `/admin/accounts/${accountId}/security`,
    request,
  )
  return response.data
}

/**
 * 所属の状態を変更する（無ければ作成する。設計書 §7.2）。
 * ADMIN 専用。対象組織はパスで明示するため、選択中の組織には依存しない。
 */
export const updateAdminAccountMembership = async (
  accountId: number,
  organizationId: number,
  request: TUpdateAdminAccountMembershipRequest,
): Promise<TAdminAccount> => {
  const response = await axios.put<TAdminAccount>(
    `/admin/accounts/${accountId}/memberships/${organizationId}`,
    request,
  )
  return response.data
}
